"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertFeatureKeysValid = void 0;
exports.resolveFeatureKeysForSlugs = resolveFeatureKeysForSlugs;
exports.resolveUserEntitlementsFromSlugs = resolveUserEntitlementsFromSlugs;
exports.userHasFeature = userHasFeature;
exports.packageIncludesFeature = packageIncludesFeature;
const package_billing_1 = require("./package-billing");
const package_features_1 = require("./package-features");
Object.defineProperty(exports, "assertFeatureKeysValid", { enumerable: true, get: function () { return package_features_1.assertFeatureKeysValid; } });
/** Union featureKeys για expanded slugs. */
function resolveFeatureKeysForSlugs(catalog, slugs) {
    var _a;
    const bySlug = new Map(catalog.map((p) => [p.slug, p]));
    const expanded = (0, package_billing_1.expandPackageIncludes)(catalog, Array.from(slugs));
    const out = new Set();
    for (const slug of expanded) {
        const pkg = bySlug.get(slug);
        if (!((_a = pkg === null || pkg === void 0 ? void 0 : pkg.featureKeys) === null || _a === void 0 ? void 0 : _a.length))
            continue;
        for (const key of (0, package_features_1.assertFeatureKeysValid)(pkg.featureKeys)) {
            out.add(key);
        }
    }
    return out;
}
/** Union feature entitlements από expanded slugs. */
function resolveUserEntitlementsFromSlugs(catalog, slugs) {
    const expanded = (0, package_billing_1.expandPackageIncludes)(catalog, Array.from(slugs));
    return Array.from(resolveFeatureKeysForSlugs(catalog, expanded));
}
function userHasFeature(entitlements, featureId) {
    for (const id of entitlements) {
        if (id === featureId)
            return true;
    }
    return false;
}
/** Αν το slug (με includes) περιλαμβάνει feature. */
function packageIncludesFeature(catalog, slug, featureId) {
    const keys = resolveFeatureKeysForSlugs(catalog, [slug]);
    return keys.has(featureId);
}
